<p class="helppoint-title">{{data.title}}</p>
<p class="helppoint-text">{{data.text}}</p>
<div align="end">
    <button mat-raised-button class="helppoint-button" (click)="onClose()" color="primary">{{'OK.PROMPT' | translate}}</button>
</div>